import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


import Swal from 'sweetalert2'

import { Button, Checkbox, Grid, TextField, Box, Divider, Typography, Tooltip } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import darkTheme from './paymentTheme';

import PayPalForm from './payPal';
import request from '../utils/request';
import TitleService from '../Title/TitleService';

import { storage } from '../firebase/firebase'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { async } from '@firebase/util';

function PaymentForm() {
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();

  const [cards, setCards] = useState([{ quantity: 1, name: '', cardSet: '', cardNumber: ''}]);
  const [uploadImage, setUploadImage] = useState(null);
  const [services, setServices] = useState([]);
  const [email, setEmail] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [priceService, setPriceService] = useState(location.state.price);
  const [discount, setDiscount] = useState(0);
  const [totalCards, setTotalCards] = useState(0);
  const [totalPrice, setTotalPrice] = useState(priceService);
  const [comments, setComments] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleChange = (index, event) => {
    const values = [...cards];
    if (event.target.type === 'checkbox') {
      values[index][event.target.name] = event.target.checked;
    } else {
      values[index][event.target.name] = event.target.value;
    }
    setCards(values);
  };

  const handleAddField = () => {
    const values = [...cards];
    values.push({ quantity: 1, name: '', cardSet: '', cardNumber: '', includeSiliconCase: false });
    setCards(values);
  };

  const handleRemoveField = (index) => {
    if (cards.length === 1) return;
    const values = [...cards];
    values.splice(index, 1);
    setCards(values);
  };

  const uploadVoucher = () => {
    if (!email || !new URLSearchParams(window.location.search).get('grading') || !uploadImage) {
      Swal.fire({
        title: 'No has llenado todos los campos.',
        text: 'Llena todos los campos para poder enviar tu solicitud.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      return;
    }

    cards.forEach((card) => {
      if (!card.name || !card.cardSet || !card.cardNumber) {
        Swal.fire({
          title: 'Los campos en las tarjetas no están llenos.',
          text: 'Llena todos los campos para poder enviar tu solicitud.',
          icon: 'warning',
          confirmButtonText: 'Ok',
        });
        return;
      }});

        Swal.fire({
          title: 'Confirma los datos:',
          html: get_HTML(cards, priceService, discount, totalPrice),
          imageUrl: URL.createObjectURL(uploadImage),
          imageHeight: 150,
          imageWidth: 250,
          imageAlt: 'Voucher',
          icon: 'success',
          confirmButtonText: 'Ok',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(async (result) => {
          if (result.isDismissed) return;
          const fileName = `Vouchers/${uuidv4()}_${uploadImage.name}`;
          const storageRef = ref(storage, fileName);
          uploadBytes(storageRef, uploadImage).then(async (snapshot) => {
            const url = await getDownloadURL(ref(storage, fileName))
            console.log(url)
            URL.revokeObjectURL(uploadImage);
            await request.save_Payment({
              email: email,
              service: new URLSearchParams(window.location.search).get('grading'),
              coupon: coupon,
              voucher: url,
              comments: comments,
              cards: cards,
            });
          }).catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error al guardar el voucher.',
              html: `<p>Oh! Algo salió mal</p><br/><p>${error}</p>`,
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          })
          Swal.fire({
            title: 'Tarjetas guardadas.',
            text: 'Se envió un correo con la información de tu compra. Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam.',
            icon: 'success',
            confirmButtonText: 'Ok',
          }).then(() => { navigate('/'); });
        }).catch((error) => {
          Swal.fire({
            title: 'Error al guardar las tarjetas.',
            html: `<p>Oh! Algo salió mal</p><br/><p>${error}</p>`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        });
  };

  async function fetchCoupon(coupon){
    if (!coupon) {
      Swal.fire({
        title: 'No has escrito ningún cupón.',
        text: 'Escribe el cupón que quieres aplicar.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      return
    };
    if (discount) {
      Swal.fire({
        title: 'Ya tienes un cupón aplicado.',
        text: 'No puedes aplicar mas de un cupon a la vez.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      return;
    };
    try {
      await request.get_Coupon(coupon).then((data) => {
        if (data.success) {
          setDiscount(data.discount);
          Swal.fire({
            title: 'Cupón aplicado.',
            text: 'El cupón se aplicó correctamente.',
            icon: 'success',
            confirmButtonText: 'Ok',
          });
        } else {
          Swal.fire({
            title: 'Cupón inválido.',
            text: 'El cupón no es válido. Asegurate de escribirlo en minusculas.',
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error al aplicar el cupón.',
        text: 'Ocurrió un error al aplicar el cupón. Intenta de nuevo.',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
    }
  }

  useEffect(() => {
    async function fetchData() {
        setServices(await request.get_Data());
        services.filter((service) => service.Name === new URLSearchParams(window.location.search).get('grading'));
    }
    fetchData();
  }, [services]);


  useEffect(() => {
    setTotalCards(
      parseInt(
        cards.reduce((accumulator, currentValue) => {
          return parseInt(accumulator) + parseInt(currentValue.quantity);
        }, 0)
      )
    );
    setTotalPrice(
      parseInt(
        cards.reduce((accumulator, currentValue) => {
          return parseInt(accumulator) + parseInt(currentValue.quantity);
        }, 0)
      ) *priceService * ( discount ? discount : 1 )
        );
  }, [cards, discount]);

  return (
    <ThemeProvider theme={darkTheme} >
      <TitleService service={new URLSearchParams(window.location.search).get('grading')} />
      <form onSubmit={handleSubmit}>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" flexWrap="wrap" gap={2} sx={{ mt: 4 }}>
          {cards.map((field, index) => (
            <Box key={index} display="flex" flexDirection="row" alignItems="center" gap={2} sx={{ minWidth: 0 }}>
              <TextField label="Quantity" name="quantity" type="number" steps="1" inputProps={{ min: 1 }} value={field.quantity} onChange={(e) => handleChange(index, e)} required/>
              <TextField label="Name" name="name" value={field.name} onChange={(e) => handleChange(index, e)} required/>
              <TextField label="Set" name="cardSet" value={field.cardSet} onChange={(e) => handleChange(index, e)} required/>
              <TextField label="Card Number" name="cardNumber" type="number" steps="1" value={field.cardNumber} onChange={(e) => handleChange(index, e)} required/>
                <Button variant="contained" color="primary" onClick={handleAddField}>
                  Agregar
                </Button>
                <Button variant="contained" color="secondary" onClick={() => handleRemoveField(index)}>
                  Quitar
                </Button>
            </Box>
          ))}
        </Box>
      </form>
      <Divider className={classes.separator} variant="middle" />
          <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" gap={2} sx={{ mt: 3 }}>
            <input type="file" onChange={(event) => {setUploadImage(event.target.files[0])}} style={{margin: "1% 5%", color: "#FFF"}} accept="image/jpeg, image/png" required></input>
             <TextField label="Email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} style={{margin: "1% 3%"}} required/>
             <TextField label="Comentarios" name="comment" value={comments} onChange={(e) => setComments(e.target.value)} style={{margin: "1% 3%"}}/>
             <TextField label="Coupon" name="coupon" value={coupon} onChange={(e) => setCoupon(e.target.value)} style={{margin: "1% 2% 1% 5%"}} pattern="[a-z]+"/>
             <Button variant="contained" color="tertiary" onClick={() => fetchCoupon(coupon)}>Revisar</Button>
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center" className={classes.removeOverflow}>
      <Grid container spacing={2} className={classes.removeOverflow}>
        <Grid item xs={6} justify="center" align="center" className={classes.removeOverflow}>
          <img
          onClick={
            () => {
              navigator.clipboard.writeText("904369899");
              Swal.fire({
                title: 'Cuenta de BAC copiada.',
                text: 'La cuenta de BAC fue copiada al portapapeles.',
                icon: 'success',
                position: "top-end",
                showConfirmButton: false,
                timer: 1350,
                width: "20%"
              });
            }
          }
            src={require('../../img/BAC_Cuenta.png')}
            alt="BAC Cuenta"
            className={`${classes.image}`}
          />
        </Grid>
        <Grid item xs={6} justify="center" align="center" className={classes.removeOverflow}>
          <img
          onClick={
            () => {
              navigator.clipboard.writeText("5614719");
              Swal.fire({
                title: 'Cuenta de BI copiada.',
                text: 'La cuenta de BI fue copiada al portapapeles.',
                icon: 'success',
                position: "top-end",
                showConfirmButton: false,
                timer: 1350,
                width: "20%"
              });
            }}
            src={require('../../img/BI_Cuenta.png')}
            alt="BI Cuenta"
            className={`${classes.image}`}
          />
        </Grid>
      </Grid>
    </Box>
          <Typography variant="h6" style={{margin: "1% 5%"}} className={ classes.whiteLetter }>
              Total (Q): { totalPrice * 8 }
          </Typography>
            <Button variant="contained" color="primary" type="submit" onClick={uploadVoucher} className={classes.submitBtn}>
              Solicitar
            </Button>
      <Divider className={classes.separator} variant="middle" />
      <div className={classes.hrWithText}>
        {/* <PayPalForm price={ priceService } coupon={ discount } cards={ totalCards } /> */}
    </div>
    </ThemeProvider>
  );
}

const useStyles = makeStyles((theme) => ({
  submitBtn: {
    margin: "1% 0 0 85%",
  },
  separator: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: "1px solid #666565",
    overflow: "hidden",
  },
  hrWithText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  hrText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: "#FFF",
  },
  whiteLetter: {
    color: "#FFF",
  },
  removeOverflow: {
    overflow: "hidden",
  },
  image: {
    overflow: 'hidden',
    maxWidth: '50%',
    height: 'auto',
    display: 'block',
    opacity: 0.8,
    transition: 'transform 0.3s ease-out',
    '&:hover': {
      opacity: 1,
      transform: 'scale(1.1)',
    },
  },
}));

export default PaymentForm;

function get_HTML(cards, price, discount, totalPrice){
  return `
  <style>html {
    font-family: Open Sans, Helvetica, sans-serif;
  }
  
  caption {
    font-size: 1.5rem;
    margin-bottom: 1.2rem;
  }
  
  table {
    table-layout: auto;
    border-spacing: 0;
    border-collapse: collapse;
    width: 450px;
    margin: 40px auto;
  }
  
  table th,
  table td {
    border: 1px solid black;
    vertical-align: top;
  }
  
  .col-item-name {
    width: 60%;
  }
  
  .col-quantity,
  .col-price {
    width: 20%;
  }
  
  table th {
    color: #000;
    text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.4);
  }
  
  table tbody tr:nth-child(even) td {
    background-color: #dcdcdc;
  }
  
  .price_txt {
    text-align: right;
    font-weight: bold;
  }</style>
  <table border="3" cellpadding="10" cellspacing="0">
   <caption>Grading para GT</caption>
   <thead>
      <colgroup>
         <col width="60%">
         <col width="20%">
         <col width="20%" span="1" style="background-color:#f1f1f1;">
      </colgroup>
      <tr>
         <th align="left" class="col-item-name">Carta</th>
         <th align="center" class="col-quantity">Cantidad</th>
         <th align="center" class="col-price">Precio</th>
      </tr>
   </thead>
   <tbody>
   `+ cards.map((card) => (
     `<tr key=${card.id}>
       <td>${card.name}</td>
       <td align="center">${card.quantity}</td>
       <td align="center">
         ${discount
           ? (card.quantity * price * discount) * 8
           : card.quantity * price * 8}
       </td>
     </tr>`
   )) +
 `</tbody> 
   <tfoot>
      <td class="price_txt" scope="col" colspan="2">Precio Total</td>
      <td align="center" >Q${ totalPrice * 8 }</td>
   </tfoot>
</table>
  `
}

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}